import React from 'react';

interface LinkedInIconProps {
  className?: string;
}

const LinkedInIcon: React.FC<LinkedInIconProps> = ({ className }) => (
  <i
    className={['fa-brands fa-linkedin', className].filter(Boolean).join(' ')}
    aria-hidden="true"
  />
);

export default LinkedInIcon;
